import {BaseModel} from "../base";
import {eventChain} from "../../services/event_chain";

class AdminEventChainModel extends BaseModel {

    constructor(data) {
        super(data);
    }

    static $query(params) {
        return eventChain.query(params);
    }
}

export {
    AdminEventChainModel
}
